<template>
	<div class="operation_box">
		<div class="operation_item">
			<md-button :class="[buttonClass, {'md-just-icon': iconClass && !buttonText}]" @click="doAction">
				<i v-if="iconClass" class="fa" :class="iconClass" />
				<span v-if="buttonText">{{ buttonText }}</span>
			</md-button>
		</div>
	</div>
</template>

<script>

export default {
	computed: {
		iconClass() {
			return this.params.iconClass;
		},
		buttonClass() {
			return this.params.buttonClass ?? "md-primary";
		},
		buttonText() {
			return this.params.buttonText;
		},
	},
    methods: {
        doAction() {
            this.params.action(this.params.data);
        }
    }
};
</script>
